<template>
  <AppDialog
    v-model="visible"
    title="选择直播间"
    width="1200px"
    class="dialogBox"
    :loading="sureLoading"
    :top="top"
  >
    <!-- 选择直播间弹框 -->
    <div class="selectLiveRoomScript">
      <div class="filterHeader">
        <span class="formLabel">直播间名称</span>
        <el-input
          v-model.trim="search.liveRoom.value"
          style="width: 300px"
          :placeholder="`请输入学员${
            { liveRoomName: '直播间名称', liveRoomCode: '直播间ID' }[
              search.liveRoom.label
            ]
          }`"
          clearable
        >
          <el-select
            slot="prepend"
            v-model="search.liveRoom.label"
            style="width: 120px"
            placeholder="请选择"
          >
            <el-option label="直播间名称" value="liveRoomName" />
            <el-option label="直播间ID" value="liveRoomCode" />
          </el-select>
        </el-input>
        <span class="formLabel" style="margin-left: 20px">直播模式</span>
        <m-select
          v-model="search.liveModel"
          dict-key="LIVE_MODE_OPTION"
          :all="true"
          style="width: 270px"
        />
        <span class="formLabel" style="margin-left: 20px">直播状态</span>
        <m-select
          v-model="search.status"
          dict-key="LIVE_STATE_OPTION"
          style="width: 270px"
        />

        <!-- <span class="formLabel">开播时间</span> -->
        <div style="margin-top: 10px">
          <m-select
            v-model="search.time.label"
            class="mySelect"
            :clearable="false"
            style="max-width: 115px; margin-right: -3px"
            dict-key="TIME_LIVE_TYPE"
          />
          <el-date-picker
            v-model="search.time.value"
            size="small"
            class="input-with-time"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :unlink-panels="true"
            @change="handleClickSearch"
          />
          <el-select
            v-model="search.teacher.label"
            size="small"
            placeholder="请选择"
            style="width: 120px; margin-left: 10px"
            @change="onhandleTearchChange"
          >
            <el-option label="真人IP" value="realityTeacherUserId" />
            <el-option label="视频IP" value="videoTeacherId" />
          </el-select>
          <m-select
            v-if="search.teacher.label === 'realityTeacherUserId'"
            v-model="search.teacher.value"
            class="select-secord"
            clearable
            style="width: 200px"
            remote
            reserve-keyword
            :dict-list="userArray"
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :param="{ value: 'userId', label: 'userName' }"
          />
          <AppSelect
            v-if="search.teacher.label === 'videoTeacherId'"
            class="filter_teacherSelect"
            :get-api-fn="getTeacherList"
            search-key="teacherName"
            :value="search.teacher.value"
            :label="search.teacherName"
            :props="{
              label: 'teacherName',
              value: 'teacherId'
            }"
            @selected="selectedTeacher"
          />
          <el-button
            size="small"
            class="m-l-10"
            type="primary"
            @click="searchFn"
          >搜索</el-button>
          <el-button
            size="small"
            class="m-l-10"
            @click="resetFn"
          >重置</el-button>
        </div>
      </div>
      <div v-loading="loading" class="myTable">
        <el-table
          height="452"
          :header-cell-style="{ background: '#F3F3F3' }"
          :data="list"
          row-key="id"
          @row-click="rowClick"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            width="55"
            align="center"
            type="selection"
            :reserve-selection="true"
          >
            <template slot-scope="{ row }">
              <el-checkbox
                :value="selectIdsList.includes(row.id)"
                @change="rowClick(row)"
              />
            </template>
          </el-table-column>
          <el-table-column prop="code" label="直播间ID" width="100" />
          <el-table-column
            label="直播间名称"
            prop="name"
            min-width="120px"
            show-overflow-tooltip
          />
          <el-table-column
            label="直播场景"
            prop="type"
            width="80px"
            align="center"
          >
            <template slot-scope="{ row }">
              {{ { 1: '正式', 2: '测试' }[row.type] }}
            </template>
          </el-table-column>
          <el-table-column label="直播类型" width="80px" prop="feesType">
            <template slot-scope="{ row }">
              {{ row.feesType === 1 ? '免费' : '付费' }}
            </template>
          </el-table-column>
          <el-table-column label="直播模式" prop="liveModel" min-width="100px">
            <template slot-scope="{ row }">
              <div class="liveMode" :class="`liveMode${row.liveModel}`">
                <div style="display: flex; align-items: center">
                  <!-- <svg-icon
                    class-name="liveModeicon"
                    :icon-class="
                      getOptionsValueByKey(
                        'value',
                        'icon',
                        row.liveModel,
                        liveModeOption
                      )
                    "
                  /> -->
                  {{ row.liveModel | getOptionsValue(liveModeOption) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="讲师"
            prop="teacherInfoDtoList"
            min-width="120px"
          >
            <template slot-scope="{ row }">
              <!-- {{ renderTearch(row) }} -->
              <textShowMore :line-clamp="1" :text="renderTearch(row)" />
            </template>
          </el-table-column>
          <el-table-column label="开播时间" prop="startTime" min-width="152px">
            <template slot-scope="{ row }">
              {{ moment(row.startTime).format('YYYY-MM-DD HH:mm:ss') }}
            </template>
          </el-table-column>
          <el-table-column label="直播状态" prop="status" min-width="114px">
            <template slot-scope="{ row }">
              <div class="liveType" :class="`liveType${row.status}`">
                <div style="display: flex; align-items: center">
                  <!-- <svg-icon
                    class-name="liveTypeicon"
                    :icon-class="
                      {
                        0: 'livenostart',
                        1: 'liveIng',
                        2: 'liveSuspend',
                        3: 'liveError',
                        9: 'audit_info'
                      }[row.status]
                    "
                  /> -->
                  {{ row.status | getOptionsValue(liveStateOption) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建人"
            prop="createUserName"
            min-width="114px"
          />
        </el-table>
        <div class="pagination">
          <div class="tipsError">
            <span class="tips">已选{{ selectList.length }}项</span>
            <!-- <span v-if="selectList.length > 10" class="m-l-10"
              >你勾选的直播间超出10个，建议重新选择。</span
            > -->
          </div>
          <el-pagination
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <div slot="footer">
      <div class="ss-material-box-bottom">
        <el-button type="primary" size="small" @click="sure">确认</el-button>
        <el-button size="small" @click="closeFn">取消</el-button>
      </div>
    </div>
  </AppDialog>
</template>

<script>
import { getOptionsValueByKey } from '@/filters/index'
import AppDialog from '@/components/AppDialog'
import { getTeacherList } from '@/api/tearchCenter/index'
import textShowMore from '@/components/textShowMore/index2'
import { getLiveRoomList } from '@/api/liveRoom/index.js'
import AppSelect from '@/components/AppSelect/index'
import { userNoPage } from '@/api/addressBookApi'
import { liveModeOption } from '@/views/live/columns.js'
const liveStateOption = [
  { label: '未开始', value: 0 },
  { label: '直播中', value: 1 },
  { label: '直播暂停', value: 2 },
  { label: '直播异常', value: 3 },
  { label: '直播结束', value: 9 },
  { label: '加载中', value: '-1' }
]
import moment from 'moment'
export default {
  components: {
    AppDialog,
    textShowMore,
    AppSelect
  },
  filters: {},

  props: {
    successFn: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      liveModeOption,
      liveStateOption,
      top: '114px',
      sureLoading: false,
      userArray: [],
      loading: false,
      visible: false,
      list: [],
      scriptId: '',
      search: {
        liveRoom: { label: 'liveRoomName', value: '' }, // 学员搜索
        teacher: { label: 'realityTeacherUserId', value: '' }, // 讲师搜索
        teacherName: '',
        status: '',
        ipTeacherIds: [],
        ipType: 1,
        time: {
          value: ['', ''],
          label: 0
        }
      },
      currentPage: 1,
      pageSize: 10,
      success: () => {},
      total: 0,
      selectList: []
    }
  },
  computed: {
    selectIdsList() {
      return this.selectList.reduce((pre, next) => {
        pre.push(next.id)
        return pre
      }, [])
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            val && this.getList()
          })
        }
      },
      deep: true
    }
  },
  beforeDestroy() {},
  mounted() {
    this.top = Math.abs(window.innerHeight - 740) / 2 + 'px'
    this.loadUserNoPage()
  },
  methods: {
    moment,
    getOptionsValueByKey,
    renderTearch(row) {
      if (row.liveModel === 'PERSON_LIVE') {
        const arr = row.teacherInfoDtoList
        if (!arr) {
          return ''
        }
        const value = arr
          .filter(v => v.teacherRole === 0)
          .reduce((pre, next) => {
            next && (pre = `${pre}${pre ? '、' : ''}${next.teacherName}`)
            return pre
          }, '')
        return value
      } else if (row.liveModel === 'AI_LIVE') {
        return row.videoTeacherName || '——'
      } else {
        return ''
      }
    },
    getTeacherList(params) {
      const data = {
        pageIndex: params.current,
        pageSize: params.size,
        teacherName: params.teacherName,
        serviceEnterprise: '',
        domainId: '',
        cooperateStatus: '',
        assessStatus: '',
        searchDateStart: '',
        searchDateEnd: '',
        createTimeBegin: '',
        createTimeEnd: '',
        assessResult: '',
        recommendName: '',
        createUserName: '',
        assessFlag: ''
      }
      return getTeacherList(data).then(res => {
        return {
          items: res.data.items,
          total: res.data.total
        }
      })
    },
    loadUserNoPage() {
      const params = {
        nickName: ''
      }
      userNoPage(params).then(res => {
        this.userArray = res.data
      })
    },
    remoteMethod(query) {
      userNoPage({ nickName: query }).then(res => {
        this.userArray = res.data
      })
    },
    open(data) {
      this.selectList = [...data] || []
      this.visible = true
    },
    resetFn() {
      this.search = {
        liveRoom: { label: 'liveRoomName', value: '' }, // 学员搜索
        teacher: { label: 'realityTeacherUserId', value: '' }, // 讲师搜索
        teacherName: '',
        status: '',
        ipTeacherIds: [],
        ipType: 1,
        time: {
          value: ['', ''],
          label: 0
        }
      }
      this.searchFn()
    },
    searchFn() {
      this.currentPage = 1
      this.getList()
    },
    selectedTeacher(res) {
      this.search.teacher.value = res.teacherId
      this.search.teacherName = res.teacherName
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    rowClick(row) {
      const index = this.selectIdsList.findIndex(v => v === row.id)
      if (index > -1) {
        this.selectList.splice(index, 1)
      } else {
        this.selectList.push(row)
      }
    },
    sure() {
      this.closeFn()
      this.$emit(
        'success',
        this.selectList.map(item => ({ id: item.id, name: item.name }))
      )
    },
    onhandleTearchChange() {
      this.search.teacher.value = ''
    },
    getList() {
      this.loading = true
      const data = {
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        timeType: this.search.time.label,
        status: this.search.status,
        ipTeacherIds: this.search.ipTeacherIds,
        [this.search.teacher.label]: this.search.teacher.value,
        liveModel: this.search.liveModel,
        [this.search.liveRoom.label]: this.search.liveRoom.value,
        startTime:
          this.search.time.value && this.search.time.value[0]
            ? this.search.time.value[0] + ' 00:00:00'
            : '',
        endTime:
          this.search.time.value && this.search.time.value[1]
            ? this.search.time.value[1] + ' 23:59:59'
            : ''
      }
      getLiveRoomList(data)
        .then(res => {
          this.list = res.data.items
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    closeFn() {
      this.visible = false
    },
    handleClickSearch() {
      this.searchFn()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialogBox::v-deep {
  .dialog-body-content {
    height: auto !important;
  }
}
.selectLiveRoomScript {
  padding: 20px;
  .filterHeader {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .formLabel {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      margin-right: 8px;
    }
  }
  .myTable {
    width: 100%;
    margin-top: 20px;
    height: 500px;
    background: #ffffff;
    border-radius: 6px;
    border: 1px solid #cbcfd3;
    overflow: hidden;
  }
  .pagination {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // justify-content: right;
  }
}
.liveType,
.liveMode {
  display: inline-block;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  padding: 0 8px;
  border-radius: 13px;
  font-size: 10px;
  font-family: MicrosoftYaHei;
  height: 24px;
  line-height: 24px;
  .liveTypeicon,
  .liveModeicon {
    width: 13px;
    height: 13px;
    font-size: 13px;
    margin-right: 4px;
  }
}
.liveType0 {
  background: #eef2f9;
  color: #717f99;
}
.liveType1 {
  background: #e7f0ff;
  color: #1778ff;
}
.liveType2 {
  background: #fff2e6;
  color: #ff7d00;
}
.liveType3 {
  background: #feecec;
  color: #f53f3f;
}
.liveType9 {
  background: #f5f5f5;
  color: #999999;
}
.liveModePERSON_LIVE {
  background: #e7f0ff;
  color: #0c6fff;
}
.liveModeAI_LIVE {
  background: #e6f7ea;
  color: #00b42a;
}
.liveModeDIGITAL_PERSON_LIVE {
  background: #e7f9ff;
  color: #0099ff;
}
.tipsError {
  color: red;
  .tips {
    padding-left: 10px;
    color: #777;
  }
}
</style>
